import Axios from 'axios'
import every from 'lodash/every'
import get from 'lodash/get'
import keys from 'lodash/keys'
import { validatePassword, validateEmail } from '..'

export const signup = () => {
  const fieldValidity = {
    email: false,
    password: false,
  }

  /**
   * Helper function that enables or disables the create account button
   * by checking the validity of the fields in `fieldValidity`
   */
  const enableOrDisableCreateAccountButton = () => {
    const fields = keys(fieldValidity)
    const areAllFieldsValid = every(fields, (field) => fieldValidity[field])
    const isRecaptchaValid = grecaptcha.getResponse().length !== 0

    if (areAllFieldsValid && isRecaptchaValid) {
      createAccountButton.disabled = false
      createAccountButton.style.opacity = 1
    } else {
      createAccountButton.disabled = true
      createAccountButton.style.opacity = 0.5
    }
  }

  async function initialiseSignupForm() {
    const createAccountButton = document.getElementById('create-account-button')
    createAccountButton.disabled = true
    createAccountButton.style.opacity = 0.5

    const path = window.location.pathname
    if (path.includes('/signup')) {
      // Reset form fields
      const form = document.getElementById('wf-form-Signup-Basic')
      form.reset()
      const res = await Axios.get('/sso-signup-info')

      if (res.status === 200 && res.data.email) {
        fieldValidity.email = true
        fieldValidity.password = true

        const emailInputField = document.getElementById('email')
        const passwordInputField = document.getElementById('password')

        emailInputField.disabled = true
        passwordInputField.disabled = true
        createAccountButton.disabled = false
        createAccountButton.value = 'Creating account...'
        createAccountButton.style.opacity = 0.5

        // Programmatically initiate account creation
        createAccountButton.click()
      }
    }
  }

  initialiseSignupForm()

  const emailError = document.getElementById('email-error')
  const passwordError = document.getElementById('password-error')
  const createAccountButton = document.getElementById('create-account-button')

  // Validate email while email is being entered
  if (document.getElementById('email')) {
    document.getElementById('email').oninput = async function () {
      if (validateEmail(this.value)) {
        const emailValue = this.value
        const form = new FormData()
        form.append('email', emailValue)
        const emailValidationResult = await Axios.post('/validate-email', form, {
          'Content-Type': 'multipart/form-data',
        })

        if (!emailValidationResult.data.success) {
          this.classList.add('text-input-invalid')
          this.classList.remove('text-input', 'text-input-valid')
          emailError.removeAttribute('hidden')
          emailError.innerText = 'Email already exists, please login to continue.'

          fieldValidity.email = false
          enableOrDisableCreateAccountButton()
        } else {
          this.classList.add('text-input-valid')
          this.classList.remove('text-input', 'text-input-invalid')
          emailError.setAttribute('hidden', true)

          fieldValidity.email = true
          enableOrDisableCreateAccountButton()
        }
      } else {
        this.classList.add('text-input-invalid')
        this.classList.remove('text-input', 'text-input-valid')
        emailError.removeAttribute('hidden')
        emailError.innerText = "That email doesn't look right, please try again."

        fieldValidity.email = false
        enableOrDisableCreateAccountButton()
      }
    }
  }

  // Validate password while password is being entered
  if (document.getElementById('password')) {
    document.getElementById('password').oninput = async function () {
      const isPwdValid = this.value.length > 0 && validatePassword(this.value)

      if (!isPwdValid) {
        if (this.value.length !== 0) {
          this.classList.remove('text-input-valid')
          this.classList.add('text-input-invalid')
          passwordError.removeAttribute('hidden')
        }

        fieldValidity.password = false
        enableOrDisableCreateAccountButton()
      } else {
        this.classList.remove('text-input-invalid')
        this.classList.add('text-input-valid')
        passwordError.setAttribute('hidden', true)
        fieldValidity.password = true
        enableOrDisableCreateAccountButton()
      }
    }
  }

  // Submit form
  if (document.getElementById('wf-form-Signup-Basic')) {
    document.getElementById('wf-form-Signup-Basic').onsubmit = async function (e) {
      e.preventDefault()
      e.stopPropagation()

      if (fieldValidity.email && fieldValidity.password) {
        const createAccountButton = document.getElementById('create-account-button')
        createAccountButton.disabled = true
        createAccountButton.style.opacity = 0.5
        createAccountButton.value = 'Creating account...'

        const formData = new FormData(this)
        const formSubmissionResponse = await Axios.post('/submit', formData, {
          'Content-Type': 'multipart/form-data',
        })

        if (formSubmissionResponse.status === 200) {
          const { portalID, formID: _formID, userId } = formSubmissionResponse.data
          const formID = this.hubsportformid || _formID

          // send the data to hubspot
          const hubSpotFormFields = [
            'firstname',
            'lastname',
            'email',
            'phone',
            'company',
            'plan_status',
            'how_too_site_url_2',
          ]

          const fields = new Array()

          hubSpotFormFields.forEach((fieldName) => {
            const formData = get(formSubmissionResponse.data, `hubspotFormData.${fieldName}`)
            if (formData) {
              const field = {
                name: fieldName,
                value: formData,
              }
              fields.push(field)
            }
          })

          const hbFormBody = {
            fields: fields,
          }

          const matched = document.cookie.match('(^|[^;]+)\\s*hubspotutk\\s*=\\s*([^;]+)')
          const cookie = matched ? matched.pop() : ''

          if (matched) {
            hbFormBody.context = {
              hutk: cookie,
              pageUri: 'www.howtoo.co',
              pageName: 'HowToo Website',
            }
          } else {
            hbFormBody.context = {
              pageUri: 'www.howtoo.co',
              pageName: 'HowToo Website',
            }
          }

          const url = `https://api.hsforms.com/submissions/v3/integration/submit/${portalID}/${formID}`
          const formattedHbBody = JSON.stringify(hbFormBody)
          const config = {
            headers: {
              'Content-Type': 'application/json',
            },
          }

          await Axios.post(url, formattedHbBody, config)

          if (window.analytics) {
            await window.analytics.identify(userId)
          }

          const { redirect } = formSubmissionResponse.data
          window.location = redirect
        } else {
          createAccountButton.removeAttribute('disabled')
          createAccountButton.style.opacity = 1
          console.error(formSubmissionResponse.status)
        }
      }
    }
  }

  if (document.getElementById('google-oauth-signup')) {
    document.getElementById('google-oauth-signup').onclick = async () => {
      const body = new FormData()
      body.append('entryType', 'signup')
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
      const res = await Axios.post('/oauth/google/auth', body, config)
      const { authorizationUrl } = res.data
      window.location.replace(authorizationUrl)
    }
  }
}
